import { PathBase } from "./path-base";
import {
	type ChildPaths,
	type PathExtendable,
	type PathBaseClasses,
	type PathConstructor,
} from "./types";

export class PathImpl<T extends PathExtendable> extends PathBase {
	static readonly childPaths: PathBaseClasses[];

	constructor(protected parentPath = "") {
		super(parentPath);
		Object.assign(this, this.getChildPaths(this.path));
	}

	protected getChildPaths = (parentPath: string): ChildPaths<T["childPaths"][number]> => {
		return (
			(this.constructor as typeof PathImpl).childPaths?.reduce(
				(acc: any, PathClass) => (
					(acc[PathClass.pathKey] = new (PathClass as any)(parentPath)), acc
				),
				{},
			) ?? {}
		);
	};
}

export const Path: PathConstructor = PathImpl as any;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Path<T extends PathExtendable> = PathImpl<T> & ChildPaths<T["childPaths"][number]>;
